<template>
  <div
    :style="
      [
        `transform: scale(${scaler})`,
        `opacity:${opacifier}}`,
      ]">
    <svg
      width="100%"
      :viewBox="`0 0 ${sizeInPx} ${sizeInPx}`"
      preserveAspectRatio="xMinYMin meet"
      >
        <circle :r="props.r * 0.875" :fill="ColorMappingBG[color as keyof typeof ColorMappingBG]" :cx="`${(sizeInPx / 2)}`" :cy="`${(sizeInPx / 2)}`" />
        <SunShine :id />
    </svg>
  </div>
</template>
<script setup lang="ts">
import { computed } from 'vue';
import { Color, type TypeColor, ColorMappingBG } from '../../interfaces'
import { normalizeBetweenRange } from '../../utils'
import { SunShine } from '../../atoms'

const defaultSize = 480

export interface PropsSunCircle {
  hasCircle?: boolean
  hasScaler?: boolean
  hasOpacifier?: boolean
  color?: TypeColor
  scale?: number
  sizeInPx?: number
  r?: number
  id?: string
}
const props = withDefaults(defineProps<PropsSunCircle>(), {
  hasCircle: true,
  hasScaler: true,
  hasOpacifier: true,
  color: Color.white,
  scale: 1,
  sizeInPx: defaultSize,
  r: defaultSize * 0.4,
  id: 'sunshine'
})


const opacifier = computed(() => {
  return props.hasOpacifier ? normalizeBetweenRange(+props.scale, {min: 0.4, max:1}) : 1
})
const scaler = computed(() => {
  return props.hasScaler ? props.scale : 1
})
</script>
